'use client';

import { useDayjs } from './useDayjs';

type fmtDateVarProps = {
  start?: string;
  end?: string;
  format?: string;
};

export const fmtDateVar = ({ start, end, format }: fmtDateVarProps) => {
  const startDay = useDayjs(start);
  const endDay = useDayjs(end);

  const startDate = start && startDay.isValid() ? startDay.format(format ?? 'YYYY-MM-DD') : null;
  const endDate = end && endDay.isValid() ? endDay.format(format ?? 'YYYY-MM-DD') : null;

  if (!startDate && !endDate) return undefined;
  if (startDate && !endDate) return ['and', `>=${startDate}`];
  if (!startDate && endDate) return ['and', `<=${endDate}`];
  return ['and', `>=${startDate}`, `<=${endDate}`];
};
